import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=2624f6b7"
import script from "./DocumentDownload.vue?vue&type=script&lang=js"
export * from "./DocumentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports